import { AppLanguages } from 'interfaces'
import { WebMode } from './appManager'

export interface WebConfigParams {
  mode: WebMode | null | undefined
  lang: AppLanguages
  theme: 'dark' | 'light'
  debug: boolean
}

export const getWebConfigParams = (): WebConfigParams | null => {
  const queryString = window?.location?.search
  const params = new URLSearchParams(queryString)

  const mode = params?.get('mode') as WebMode
  return {
    lang: params?.get('lang') as AppLanguages,
    mode: mode === 'jsbridge' ? 'jsbridge' : 'normal',
    theme: params?.get('theme') as 'dark' | 'light',
    debug: params?.get('debug') === 'true' ? true : false,
  }
}
